import React, { useState } from 'react';
import { Collapse } from 'react-collapse';
import { useCookies } from 'react-cookie';
import Icon from '../Icon';
import { EditorStringModel } from '../../Types/EditorString';

const TopMessage = ({
  systemId,
  message,
  link,
}: {
  systemId: string;
  message: EditorStringModel;
  link?: string;
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const [_, setCookie] = useCookies([`top-message-${systemId}-visible`]);

  return (
    <>
      {message && (
        <Collapse isOpened={isOpen}>
          <div className="relative bg-secondary-500 text-center text-white">
            <a
              className="block py-2 pl-4 pr-8 text-md"
              href={link}
              dangerouslySetInnerHTML={{
                __html: message.value ?? '',
              }}
            ></a>
            <Icon
              className="absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 cursor-pointer"
              name="close"
              onClick={() => {
                setCookie(`top-message-${systemId}-visible`, 'close');
                setIsOpen(false);
              }}
            />
          </div>
        </Collapse>
      )}
    </>
  );
};

export default TopMessage;
